"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCorrectChoice = void 0;
const anchor_1 = require("@project-serum/anchor");
const interfaces_1 = require("./interfaces");
function getCorrectChoice(startValue, endValue) {
    if (!endValue.eq(new anchor_1.BN(0))) {
        if (startValue.gt(endValue)) {
            return interfaces_1.Bet.DOWN;
        }
        else if (startValue.lt(endValue)) {
            return interfaces_1.Bet.UP;
        }
        else {
            return interfaces_1.Bet.DRAW;
        }
    }
    return null;
}
exports.getCorrectChoice = getCorrectChoice;
